import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const floppyDiskOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3 0h6v-3H3Zm7 0h1v-7a.9.9 0 0 0-.078-.297 1 1 0 0 0-.156-.281L8.578-9.766a1 1 0 0 0-.265-.156A.9.9 0 0 0 8-10v3.25q0 .316-.219.531A.72.72 0 0 1 7.25-6h-4.5a.7.7 0 0 1-.531-.219A.7.7 0 0 1 2-6.75V-10H1V0h1v-3.25a.72.72 0 0 1 .219-.531A.72.72 0 0 1 2.75-4h6.5q.31 0 .531.219A.74.74 0 0 1 10-3.25zM7-7.25v-2.5a.22.22 0 0 0-.078-.172A.22.22 0 0 0 6.75-10h-1.5a.24.24 0 0 0-.172.078A.2.2 0 0 0 5-9.75v2.5c0 .063.023.121.078.172.05.055.11.078.172.078h1.5c.07 0 .129-.023.172-.078.05-.05.078-.11.078-.172M12-7V.25a.74.74 0 0 1-.219.531.74.74 0 0 1-.531.219H.75A.72.72 0 0 1 .219.781.72.72 0 0 1 0 .25v-10.5a.72.72 0 0 1 .219-.531A.72.72 0 0 1 .75-11H8c.207 0 .438.055.688.156q.373.158.593.375L11.47-8.28q.217.22.375.594c.101.25.156.48.156.687m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
